import { i18n } from 'next-i18next'
import { z } from 'zod'
import { recordFromEntries } from 'helpers/records'

export const MINOR_HEALTH_QUESTIONS_KEYS = [
  'hospital',
  'surgery',
  'growth',
  'weigh',
  'dizziness',
  'unconsciousness',
  'sport_injury',
  'breathing_difficulty_during_exercise',
  'breathing_difficulty_after_exercise',
  'chest_pain_or_palpitations',
  'new_daily_medication',
  'sport_interruption_due_to_health_issue',
  'fatigue',
  'sleep_issues',
  'decreased_appetite',
  'emotional_issues',
  'increased_tearfulness',
  'lingering_injury_pain_or_weakness',
  'considering_stopping_or_changing_sport',
  'need_for_medical_clearance',
  'additional_health_concerns',
  'family_medical_history',
  'family_member_weigh_problem',
  'exam_missed'
] as const

const answers = z
  .object(
    recordFromEntries(
      MINOR_HEALTH_QUESTIONS_KEYS.map((k) => [
        k,
        z.boolean({
          errorMap: () => ({
            message: i18n?.t('errors:validation.race.mandatoryAnswer') as string
          })
        })
      ])
    )
  )
  .refine(
    (answers) => !Object.values(answers).includes(true),
    `Comme tu as répondu OUI à une ou plusieurs questions, tu dois consulter un médecin pour qu'il t'examine et voie avec toi quel sport te convient.`
  )

export const HealthQuestionnaireSchema = z.object({
  completeType: z.literal('HEALTH_QUESTIONNAIRE'),
  answers
})
